/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./sandbox.vue.js?vue&type=template&id=52e1aa5d!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sandbox.vue?vue&type=template&id=52e1aa5d"
import script from "./sandbox.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sandbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./sandbox.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sandbox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./sandbox.vue.postcss?vue&type=style&index=0&id=52e1aa5d&prod&lang=postcss&module=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sandbox.vue?vue&type=style&index=0&id=52e1aa5d&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports